import React from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';
import DraggableListItem, {
	DragObject,
	RenderDragItem,
} from '@client/components/DraggableList/private/DraggableListItem';
import styles from './DraggableListDragLayer.module.css';

type DraggableListDragLayerProps<Data> = {
	width: number;
	renderItem: RenderDragItem<Data>;
};

const DraggableListDragLayer = <Data, >({
	width,
	renderItem,
}: DraggableListDragLayerProps<Data>) => {
	const {
		item,
		isDragging,
		offset,
		sourceOffset,
	} = useDragLayer<{
		item: DragObject<Data> | null;
		isDragging: boolean;
		offset: XYCoord | null;
		sourceOffset: XYCoord | null;
	}>((monitor) => ({
		isDragging: monitor.isDragging(),
		offset: monitor.getClientOffset(),
		sourceOffset: monitor.getInitialSourceClientOffset(),
		item: monitor.getItem(),
	}));

	const dragItem = item?.dragItem;

	if (!isDragging || offset == null || sourceOffset == null || dragItem == null) {
		return null;
	}

	const transform = `translate(${sourceOffset.x}px, calc(${offset.y}px - 50%))`;

	return (
		<div className={styles.container}>
			<div
				style={{
					transform,
					width,
				}}
				className={styles.element}
			>
				<DraggableListItem
					dragItem={dragItem}
					includeSeparator={false}
					index={dragItem.index}
					renderItem={renderItem}
				/>
			</div>
		</div>
	);
};

export default DraggableListDragLayer;
